import React from 'react';

export default () => {
    return (
        <>
            <p>Here is ClaimImportStatus.Home</p>
        </>
    )
}